/**
 * @generated SignedSource<<fdc3b26ca7718aac65ae162c41620f87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionMenuItem_softwareBacklog$data = {
  readonly node: {
    readonly id: string;
    readonly name: string;
    readonly versionId: string;
  };
  readonly " $fragmentType": "versionMenuItem_softwareBacklog";
};
export type versionMenuItem_softwareBacklog$key = {
  readonly " $data"?: versionMenuItem_softwareBacklog$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionMenuItem_softwareBacklog">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionMenuItem_softwareBacklog",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersion",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "id"
            },
            "action": "THROW",
            "path": "node.id"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "versionId"
            },
            "action": "THROW",
            "path": "node.versionId"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "node.name"
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    }
  ],
  "type": "JiraVersionEdge"
};

(node as any).hash = "abd3a2327d76d6cec48e7802950c72b4";

export default node;
